var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HistoryRounded"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.2605 3.00001C8.17052 2.86001 4.00052 6.95001 4.00052 12H2.21052C1.76052 12 1.54052 12.54 1.86052 12.85L4.65052 15.65C4.85052 15.85 5.16052 15.85 5.36052 15.65L8.15052 12.85C8.46052 12.54 8.24052 12 7.79052 12H6.00052C6.00052 8.10001 9.18052 4.95001 13.1005 5.00001C16.8205 5.05001 19.9505 8.18001 20.0005 11.9C20.0505 15.81 16.9005 19 13.0005 19C11.3905 19 9.90052 18.45 8.72052 17.52C8.32052 17.21 7.76052 17.24 7.40052 17.6C6.98052 18.02 7.01052 18.73 7.48052 19.09C9.00052 20.29 10.9105 21 13.0005 21C18.0505 21 22.1405 16.83 22.0005 11.74C21.8705 7.05001 17.9505 3.13001 13.2605 3.00001ZM12.7505 8.00001C12.3405 8.00001 12.0005 8.34001 12.0005 8.75001V12.43C12.0005 12.78 12.1905 13.11 12.4905 13.29L15.6105 15.14C15.9705 15.35 16.4305 15.23 16.6405 14.88C16.8505 14.52 16.7305 14.06 16.3805 13.85L13.5005 12.14V8.74001C13.5005 8.34001 13.1605 8.00001 12.7505 8.00001Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.4899fcd5a852c634d5c514b64df5c9ff.svg";
export { ForwardRef as ReactComponent };